/* eslint-disable prettier/prettier */
type User = {
  userId: string;
  email: string;
};

import { initializeApp } from "firebase/app";
import { UserCredential, getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDt4NRTmxXw1aSM9LdciYUj0chvLbMzLXQ",
  authDomain: "conroo-prod.firebaseapp.com",
  projectId: "conroo-prod",
  storageBucket: "conroo-prod.appspot.com",
  messagingSenderId: "101837009046",
  appId: "1:101837009046:web:9b8308ab874e96aa6012b7",
  measurementId: "G-VELCXP317C"
};

const app = initializeApp(firebaseConfig);


export interface Authenticator {
  login(email: string, password: string): Promise<User>;
  logout(): Promise<void>;
  getCurrentUser() : User | null;
  getAccessToken(): Promise<string | undefined>;
}


export const getAuthService = () : Authenticator => {
  const firebaseAuth =  getAuth(app);
  return {
    login : async (email : string,password:string) => {
    const result  = await signInWithEmailAndPassword(firebaseAuth,email,password);

    return {
      userId:result.user.uid,
      email,
    }
    },
    logout: async () => {
      await signOut(firebaseAuth);
    },
    getCurrentUser:  () => {
     const currentUser =  firebaseAuth.currentUser;
      if(currentUser === null) {
        return null;
      }

      return {
        email:currentUser.email ?? "",
        userId:currentUser.uid
      };

    },
    getAccessToken: async () => {
      await firebaseAuth.authStateReady();
      const currentUser = firebaseAuth.currentUser;
      return await currentUser?.getIdToken();
    }
  }
}
